var ViewApplicationBaseComponent_1;
import { __decorate } from "tslib";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { AflaModuleStrategyService } from "../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../shared/services/selected-application/selected-application.service";
import { ApplicationViewService } from "../application-view.service";
import { RouterParamsService } from "../../../shared/services/route-params.service";
import { take } from "rxjs/operators";
import { AutoUnsubPortal } from "../../../shared/decorators/autounsub-portal.decorator";
let ViewApplicationBaseComponent = class ViewApplicationBaseComponent {
    static { ViewApplicationBaseComponent_1 = this; }
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    routerParamsService;
    stepMeta;
    jobId = null;
    moduleId = null;
    selectedApplication;
    incompleteJobIdSubscription;
    selectedApplicationVABSubscription;
    routerParamsSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService) {
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.routerParamsService = routerParamsService;
        this.incompleteJobIdSubscription = this.selectedApplicationService.$incompleteJobId.subscribe((jobId) => {
            if (jobId && jobId > 0) {
                this.jobId = jobId;
            }
        });
        this.selectedApplicationVABSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            this.selectedApplication = +this.jobId > 0 && application ? application : null;
        });
    }
    static checkIfChanged(newValue, oldValue) {
        if (!newValue) {
            throw new Error("Value must exist");
        }
        return newValue !== oldValue;
    }
    getMetadata() {
        this.applicationViewService.$startMetadata.pipe(take(1)).subscribe(stepMeta => {
            if (stepMeta != null) {
                this.stepMeta = stepMeta;
                this.loadMetadata(this.stepMeta);
            }
        });
    }
    listenForRouteParamChange() {
        this.routerParamsSubscription = this.routerParamsService.params.subscribe((params) => {
            this.handleRouteParamChange(params);
        });
    }
    handleRouteParamChange(params) {
        if (params.moduleid || params.jobID) {
            if (ViewApplicationBaseComponent_1.checkIfChanged(params.jobID, this.jobId)
                || ViewApplicationBaseComponent_1.checkIfChanged(params.moduleid, this.moduleId)) {
                this.moduleId = params.moduleid;
                this.jobId = params.jobID;
                this.handleRouteChange();
            }
        }
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: RouterParamsService }
    ];
};
ViewApplicationBaseComponent = ViewApplicationBaseComponent_1 = __decorate([
    Component({
        template: "",
        changeDetection: ChangeDetectionStrategy.OnPush
    }),
    AutoUnsubPortal()
], ViewApplicationBaseComponent);
export { ViewApplicationBaseComponent };
